<template>
    <!-- Rental Deals -->
    <section class="section featured-venues">
        <div class="container">
            <div class="section-heading aos" data-aos="fade-up">
                <h2>Featured <span>Venues</span></h2>
                <p class="sub-title">Advanced sports venues offer the latest facilities, dynamic and unique environments for
                    enhanced badminton performance.</p>
            </div>
            <div class="row">
                <div class="featured-slider-group ">
                    <div class="owl-carousel featured-venues-slider owl-theme">

                        <!-- Featured Item -->
                        <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
                            <Slide v-for="item in Venues" :key="item.id">
                                <div class="featured-venues-item aos" data-aos="fade-up">
                                    <div class="listing-item mb-0">
                                        <div class="listing-img">
                                            <router-link to="/coaches/venue-details">
                                                <img :src="require(`@/assets/img/venues/${item.Image}`)" alt="Venue">
                                            </router-link>
                                            <div class="fav-item-venues">
                                                <span :class="item.Tagclass">{{ item.Tag }}</span>
                                                <h5 class="tag tag-primary">{{ item.Price }}<span>/hr</span></h5>
                                            </div>
                                        </div>
                                        <div class="listing-content text-start">
                                            <div class="list-reviews">
                                                <div class="d-flex align-items-center">
                                                    <span class="rating-bg">{{ item.Rating }}</span><span>{{ item.Review
                                                    }}</span>
                                                </div>
                                                <a href="javascript:void(0)" class="fav-icon" @click="toggleSelected(item)"
                                                    :class="{ selected: item.isSelected }">
                                                    <i class="feather-heart"></i>
                                                </a>
                                            </div>
                                            <h3 class="listing-title">
                                                <router-link to="/coaches/venue-details">{{ item.Title }}</router-link>
                                            </h3>
                                            <div class="listing-details-group">
                                                <p>{{ item.Text }}</p>
                                                <ul>
                                                    <li>
                                                        <span>
                                                            <i class="feather-map-pin"></i>{{ item.Location }}
                                                        </span>
                                                    </li>
                                                    <li>
                                                        <span>
                                                            <i class="feather-calendar"></i>Next Availablity : <span
                                                                class="primary-text">{{ item.Day }}</span>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="listing-button">
                                                <div class="listing-venue-owner">
                                                    <router-link class="navigation" to="/coaches/coach-detail">
                                                        <img :src="require(`@/assets/img/profiles/${item.Avatar}`)"
                                                            alt="Venue">{{ item.Name }}
                                                    </router-link>
                                                </div>
                                                <router-link to="/coaches/venue-details" class="user-book-now"><span><i
                                                            class="feather-calendar me-2"></i></span>Book Now</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slide>
                            <template #addons>
                                <Navigation />
                            </template>
                        </Carousel>
                        <!-- /Featured Item -->

                    </div>
                </div>
            </div>

            <!-- View More -->
            <div class="view-all text-center aos" data-aos="fade-up">
                <router-link to="/coaches/listing-grid" class="btn btn-secondary d-inline-flex align-items-center">View All
                    Featured<span class="lh-1"><i class="feather-arrow-right-circle ms-2"></i></span></router-link>
            </div>
            <!-- View More -->

        </div>
    </section>
    <!-- /Rental Deals -->
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Venues from '@/assets/json/home-venues.json'
export default {
    data() {
        return {
            Venues: Venues,
            isSelected: false,
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            breakpoints: {
                575: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                767: {
                    itemsToShow: 1,
                    snapAlign: "center",
                },
                991: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                1024: {
                    itemsToShow: 3,
                    snapAlign: "start",
                },
            },
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination
    },
    methods: {
        toggleSelected(item) {
            item.isSelected = !item.isSelected;
        },
    },
}
</script>